import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import { Balance, ErrorResponse } from 'types';

const useBalance = (): UseQueryResult<Balance, ErrorResponse> => {
  return useQuery([url.balance]);
};
export default useBalance;
